export default "__VITE_ASSET__BqRkG9RW__"